import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Track from '../views/Home.vue'
import PhoneLogin from '../views/PhoneLogin.vue'
import AccoutLogin from '../views/AccoutLogin.vue'
import Verify from '../views/VerifyCode.vue'
import Mine from '../views/Mine.vue'
import List from '../views/List.vue'
import TankFillList from '../views/TankFillList.vue'

// 配方
//import Formula from '../views/craft/formula/formula.vue'

Vue.use(VueRouter)
VueRouter.prototype.goBack = function () { 
　　this.isBack = true
　　window.history.go(-1)
}

const routes = [
	{
	  path: '/home',
	  name: 'Home',
	  component: Home,
		meta: {
			showNav: false,
			showTab: true,
			isBack: false,
			title: '首页'
		}
	},
	{
	  path: '/track',
	  name: 'Track',
	  component: Home,
		meta: {
			showNav: false,
			showTab: true,
			isBack: false,
			title: '首页'
		}
	},
	{
	  path: '/tank_fill',
	  name: 'TankFillList',
	  component: TankFillList,
		meta: {
			showNav: false,
			showTab: true,
			isBack: false,
			title: '充装记录'
		}
	}
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
